import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observe } from "mobx";
import { inject, observer } from "mobx-react";
import * as moment from 'moment-timezone';
import * as React from 'react';
import * as DateTime from 'react-datetime';
import { Prompt, withRouter } from "react-router-dom";
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from "reactstrap";
import ButtonRow from "src/Components/ButtonRow";
import DataTable from "src/Components/DataTable";
import EInput from "src/Components/EInput";
import Footer from "src/Components/Footer";
import WellFooter from "src/Components/Footer/WellFooter";
import WorkflowHeader from "src/Components/Main/WorkflowHeader";
import { IDispatch, IDispatchItemRow } from "src/Interfaces/DispatchInterface";
import { IEBPExpenseType, IProduct, IProductCategory, ITest } from "src/Interfaces/TestInterface";
import { IWell } from "src/Interfaces/WellInterface";
import { AdminStore } from "src/Stores/Admin/AdminStore";
import { DispatchStore } from "src/Stores/Dispatch/DispatchStore";
import { MessageStore } from "src/Stores/Messages/Messages";
import { TestsStore } from "src/Stores/Tests/TestsStore";
import { UserStore } from "src/Stores/User/UserStore";
import { WellsStore } from "src/Stores/Wells/WellsStore";
import WellCloseButton from "../../WellWorkflow/WellCloseButton";
import WellRevertCloseButton from "../../WellWorkflow/WellRevertCloseButton";

@inject('stores')
@observer
class Dispatch extends React.Component {

    private blankIList = {
        headers: [],
        rows: [],
    };

    public state = {
        dataTablesProducts: {
            deliveryLists: this.blankIList,
            pickupLists: this.blankIList,
            transferLists: this.blankIList,
        },
        deliveryLists: {
            expense: [] as IDispatchItemRow[],
            product: [] as IDispatchItemRow[],
        },
        destinationWellId: '',
        dispatch: new IDispatch(),
        expenseList: [] as IEBPExpenseType[],
        isDirty: false,
        modalTargetList: 'deliveryLists',
        newExpenseList: [] as IEBPExpenseType[],
        newInventoryList: [] as IProduct[],
        newProduct: new IProduct(),
        openAccord: {
            delivery: false,
            pickup: false,
            transfer: false,
        },
        pickupLists: {
            expense: [] as IDispatchItemRow[],
            product: [] as IDispatchItemRow[],
        },
        productCategories: [] as IProductCategory[],
        productList: [] as IProduct[],
        productListData: this.blankIList,
        showDispatchModal: false,
        showNewProductModal: false,
        showProductModal: false,
        tab: 'product',
        transferLists: {
            expense: [] as IDispatchItemRow[],
            product: [] as IDispatchItemRow[],
        },
        wellList: undefined as IWell[] | undefined,
    };

    public testDisposer: any;

    public props: any;
    public WellsStore: WellsStore;
    public AdminStore: AdminStore;
    public TestsStore: TestsStore;
    public MessageStore: MessageStore;
    public DispatchStore: DispatchStore;
    public UserStore: UserStore;

    constructor(props: any) {
        super(props);
        this.WellsStore = this.props.stores.WellsStore;
        this.AdminStore = this.props.stores.AdminStore;
        this.TestsStore = this.props.stores.TestsStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.DispatchStore = this.props.stores.DispatchStore;
        this.UserStore = this.props.stores.UserStore;
    }

    private getProductCategories() {
        this.TestsStore.getProductCategories()
        .then(
            (data: any) => {
                this.setState({
                    productCategories: data
                });
            }
        );
    }

    private getExpenseTypes() {
        this.TestsStore.getExpenseTypes(this.props.match.params.wellId)
            .then(
                expenseList => {
                    this.setState({expenseList});
                }
            );
    }

    private getProductTypes() {
        this.TestsStore.getProductList(this.props.match.params.wellId)
        .then(
            productList => {
                this.setState({
                    productList,
                });
            }
        );
    }

    private getExpenseLists = (test: ITest) => {
        const dispatchExpenseList = [] as IDispatchItemRow[];
        // MUD-3581 don't prepopulate
        // test.ebpInventorys.filter(e => e.expenseType.dispatchable).forEach(ebpInv => {
        //     const item = new IDispatchItemRow();
        //     item.expense = ebpInv.expenseType;
        //     item.expenseId = ebpInv.expenseType.id;
        //     item.price = ebpInv.unitPrice;
        //     dispatchExpenseList.push(item);
        // });

        const deliveryLists = this.state.deliveryLists;
        deliveryLists.expense = JSON.parse(JSON.stringify(dispatchExpenseList));
        
        const pickupLists = this.state.pickupLists;
        pickupLists.expense = JSON.parse(JSON.stringify(dispatchExpenseList));

        const transferLists = this.state.transferLists;
        transferLists.expense = JSON.parse(JSON.stringify(dispatchExpenseList));

        this.setState({
            deliveryLists,
            pickupLists,
            transferLists,
        });
    }

    private getProductLists = (test: ITest) => {
        const dispatchProductList = [] as IDispatchItemRow[];
        test.productInventorys.forEach(product => {
            const item = new IDispatchItemRow();
            item.product = product.product;
            item.productId = product.product.id;
            item.product.categorys = [product.category];
            item.closing = product.closingAmount.toString();
            item.price = product.priceUsed;
            dispatchProductList.unshift(item);
        });
        
        const deliveryLists = this.state.deliveryLists;
        deliveryLists.product = [];
        
        const pickupLists = this.state.pickupLists;
        pickupLists.product = JSON.parse(JSON.stringify(dispatchProductList));

        const transferLists = this.state.transferLists;
        transferLists.product = JSON.parse(JSON.stringify(dispatchProductList));
        
        this.setState({
            deliveryLists,
            pickupLists,
            transferLists,
        }, () => {
            this.formatAllProducts();
        });
    }

    public resetProductList = (listName: string) => {
        const lists = this.state[listName];
        const list = lists.product as IDispatchItemRow[];
        if (list && Array.isArray(list)) {
            list.forEach(item => {
                item.quantity = '';
            });
        }
        const listExpense = lists.expense as IDispatchItemRow[];
        if (listExpense && Array.isArray(listExpense)) {
            listExpense.forEach(item => {
                item.quantity = '';
            });
        }
        this.setState({
            [listName]: lists,
            showDispatchModal: false,
        }, () => {
            this.formatDataTableProduct(listName);
        });
    }

    private saveDispatch = (listName:string) => () => {
        const dispatch = this.state.dispatch;
        if (dispatch.items.length > 0) {
            this.DispatchStore.postDispatch(dispatch)
                .then(
                    dispatchId => {
                        if (dispatchId) {
                            this.MessageStore.addMessage('Dispatch created.', 'success');
                            this.resetProductList(listName);
                            if (this.props.forWell) {
                                this.DispatchStore.getDispatches();
                            }
                        }
                    }
                );
        }
    }

    private handleDispatchDateChange = (newDate: any) => {
        const dispatch = this.state.dispatch;
        const newDateValue = moment(newDate).unix();
        console.log(newDateValue);
        if (isFinite(newDateValue)) {
            dispatch.requestedArrival = newDateValue.toString();
        } else {
            dispatch.requestedArrival = undefined as unknown as string;
        }
        this.setState({
            dispatch,
        });
    }

    private handleDispatchChange = (event: any) => {
        const dispatch = this.state.dispatch;
        dispatch[event.target.name] = event.target.value;
        this.setState({
            dispatch,
        });
    }


    public formatAllExpenses() {
        console.log('Format some Expsenses');
    }
    public formatAllProducts() {
        this.formatDataTableProduct('deliveryLists');
        this.formatDataTableProduct('pickupLists');
        this.formatDataTableProduct('transferLists');
    }

    public componentDidMount() {
        this.getExpenseTypes();
        this.getProductTypes();
        this.getProductCategories();
        this.formatAllProducts();
        this.WellsStore.getWellsNoFilter()
            .then(wellList => {
                this.setState({wellList});
            });
        if (this.TestsStore.tests && this.TestsStore.tests.length > 0) {
            if (this.TestsStore.test && this.TestsStore.tests[0].id === this.TestsStore.test.id) {
                this.getProductLists(this.TestsStore.test);
                this.getExpenseLists(this.TestsStore.test);
            } else {
                this.TestsStore.getTestDetails(this.TestsStore.tests[0].id, this.props.match.params.wellId);
                // this.props.history.replace(`/well/${this.WellsStore.well.id}/test/${this.TestsStore.tests[0].id}/inventory/dispatches`);
                // this.TestsStore.getTestDetails(this.TestsStore.tests[0].id, this.props.match.params.wellId);
            }
        } else if (this.WellsStore.well) {
            this.TestsStore.getTests(this.WellsStore.well.id)
                .then( data => {
                    if (data[0]) {
                        this.TestsStore.getTestDetails(data[0].id, this.WellsStore.well.id);
                    }
                });
        } else {
            this.WellsStore.getWellDetails(this.props.match.params.wellId)
                .then(data => {
                    this.TestsStore.getTests(this.props.match.params.wellId)
                        .then( dataInner => {
                            if (dataInner[0]) {
                                this.TestsStore.getTestDetails(dataInner[0].id, data.id);
                            }
                        });
                });
        }

        this.testDisposer = observe(this.TestsStore, 'test', (change => {
            this.getProductLists(change.newValue);
            this.getExpenseLists(change.newValue);
        }));
        
    }

    private handleCheck = (listName:string, type:string, index: number) => (event: any) => {
        const list = this.state[listName];
        const row = list[type][index] as IDispatchItemRow;
        if (row.quantity > 0) {
            row.quantity = '';
        } else if (row.closing && row.closing !== 'N/A' && listName !== 'deliveryLists') {
            row.quantity = Number(row.closing);
        } else {
            row.quantity = 1;
        }
        this.setState({
            [listName]: list
        });

    }

    private handleQuantityInput = (listName:string, type:string, index: number) => (event: any) => {
        const list = this.state[listName];
        const row = list[type][index] as IDispatchItemRow;
        if (Number.isInteger(Number(event.target.value))) {
            row.quantity = Number(event.target.value);
            this.setState({
                [listName]: list
            });
        }
    }

    private handleDestWellChange = (event: any) => {
        this.setState({
            destinationWellId: event.target.value
        });
    }

    // private handleQuantityBlur = (listName:string, type:string, index: number) => (event: any) => {
    //     this.formatDataTableProduct(listName);
    // }

    public componentWillUnmount() {
        this.testDisposer();
    }

    public createDispatch = (listName: string) => () => {
        const list = this.state[listName];
        const dispatch = new IDispatch();
        switch (listName) {
            case 'deliveryLists':
                dispatch.destinationWellId = this.WellsStore.well.id;
                dispatch.type = "Delivery";
                break;
        
            case 'pickupLists':
                dispatch.sourceWellId = this.WellsStore.well.id;
                dispatch.type = "Pickup";
                break;
            
            case 'transferLists':
                dispatch.destinationWellId = this.state.destinationWellId;
                dispatch.sourceWellId = this.WellsStore.well.id;
                dispatch.type = "Transfer";
            default:
                break;
        }
        dispatch.submittedWellTestId = this.TestsStore.test && !this.props.forWell ? this.TestsStore.test.id : null;
        dispatch.submittedWellId = this.props.forWell ? this.props.forWell : null;
        list.product.forEach((element: IDispatchItemRow) => {
            if (element.quantity > 0) {
                dispatch.items.push(element);
            }
        });

        list.expense.forEach((element: IDispatchItemRow) => {
            if (element.quantity > 0) {
                dispatch.items.push(element);
            }
        });

        this.setState({
            dispatch,
            modalTargetList: listName,
            showDispatchModal: true,
        });
    }

    private createCheckBox = (listName:string, type:string, index: number, row: IDispatchItemRow) => () => {
        return <FormGroup style={{textAlign: 'center'}} >
                    <Label check={true}>
                        <Input
                            key={index}
                            type="checkbox"
                            name={`${listName}.${type}[${index}].check`}
                            checked={row.quantity > 0}
                            onChange={this.handleCheck(listName, type, index)}
                            />
                    </Label>
                </FormGroup>;
    }

    private createQuantityInput = (listName: string, type: string, index: number, row: IDispatchItemRow) => (tabIndex: number) => {
        let multiplier = 1;
        switch (listName) {
            case 'deliveryLists':
                multiplier = type === 'product' ? 1 : 2;
                break;
        
            case 'pickupLists':
                multiplier = type === 'product' ? 3 : 4;
                break;
            
            case 'transferLists':
                multiplier = type === 'product' ? 5 : 6;
                break;
            default:
                break;
        }

        const dataValidation = row.productId === null || row.productId === undefined ? "integer" : (row.product.isBulk ? "integer" : "decimal");
        return <EInput
                    key={index}
                    type="text"
                    name={`${listName}.${type}[${index}].quantity`}
                    value={row.quantity}
                    data-validation={dataValidation}
                    data-max={listName !== 'deliveryLists' && type === 'product' ? row.closing : undefined}
                    onChange={this.handleQuantityInput(listName, type, index)}
                    tabIndex={50+tabIndex*multiplier}
                />;
    }

    private formatDataTableProduct = (listName: string) => {
        const listType = 'product';
        const list = this.state[listName][listType] as IDispatchItemRow[];
        
        const headers = [
            { 
                content: '',
                width: 2,
            },
            'Product',
            'Category',
            'Unit',
            'Size',
            'Closing',
            'Quantity',
        ];

        const rows: any = [];

        list.forEach((row, index) => {
            const tempRow = [
                {
                    content: this.createCheckBox(listName, 'product', index, row),
                    type: 'render',
                },
                {
                    content: row.product.name
                },
                {
                    content: row.product.categorys.length > 0 ? row.product.categorys[0].name : ''
                },
                {
                    content: row.product.unit
                },
                {
                    content: row.product.size
                },
                {
                    content: row.closing,
                },
                {
                    content: this.createQuantityInput(listName, 'product', index, row),
                    sortItem: row.quantity,
                    type: 'render',

                }
            ];
            rows.push(tempRow);
        });

        const retList = {
            headers,
            rows,
        };
        const dataTablesProducts = this.state.dataTablesProducts;
        dataTablesProducts[listName] = retList;
        this.setState({
            dataTablesProducts,
        });

    }

    private formatDataTableExpense = (listName: string) => {
        const listType = 'expense';
        const list = this.state[listName][listType] as IDispatchItemRow[];

        const headers = [
            {
                content: '',
                width: 2,
            },
            'EBP',
            'Type',
            'Quantity',
        ];

        const rows = list.map((row, index) => [
            {
                content: this.createCheckBox(listName, 'expense', index, row),
                type: 'render',
            },
            {
                content: row.expense.name,
            },
            {
                content: row.expense.isRental ? 'Rental' : 'Service'
            },
            {
                content: this.createQuantityInput(listName, 'expense', index, row),
                sortItem: row.quantity,
                type: 'render',
            }
        ]);

        const retList = {
            headers,
            rows
        };
        
        return retList;
    }

    private filterAddProduct = (list: string) => (product: IProduct) => {
        return this.state[list].product.every((p: any) => p.productId !== product.id);
    }

    private filterAddExpense = (list: string) => (expense: IEBPExpenseType) => {
        return expense.dispatchable && this.state[list].expense.every((e: any) => e.expenseId !== expense.id);
    }

    private formatAddProductDataTable = () => {
        const newDataList: any[] = [];
        const tableHeaders = [
            'Product',
            'Category',
            'Unit',
            'Size',
            'Weight',
            'Price'
        ];
        if ( this.state.productList ) {
            this.state.productList.filter(this.filterAddProduct(this.state.modalTargetList)).map((product: IProduct, index: number) => {
                const newObject = [
                    {
                        content: product.name
                    },
                    {
                        content: product.categorys[0].name
                    },
                    {
                        content: product.unit
                    },
                    {
                        content: product.size
                    },
                    {
                        content: product.weight
                    },
                    {
                        content: product.retailPrice
                    }
                ];
                newDataList.push(newObject);
            });
        }
        return {
            headers: tableHeaders,
            rows: newDataList
        };
    }

    private formatAddExpenseDataTable = () => {
        const headers = [
            'EBP',
            'Type',
        ];
        let rows = [] as any[];
        if (this.state.expenseList) {
            rows = this.state.expenseList.filter(this.filterAddExpense(this.state.modalTargetList)).map(expense => [
                {
                    content: expense.name,
                },
                {
                    content: expense.isRental ? 'Rental' : 'Service',
                },
            ]);
        }

        return {headers, rows};
    }

    private handleSave = (listName: string, type: string) => () => {
        const typeLists = this.state[listName];
        const list = typeLists[type] as IDispatchItemRow[];
        
        if ( this.state.newInventoryList.length > 0 ) {
            this.state.newInventoryList.forEach((product: IProduct, index: number) => {
                if (!list.find(li => li.product.name === product.name)) {
                    let testProduct;
                    if (this.TestsStore.test) {
                        testProduct = this.TestsStore.test.productInventorys.find(p => p.product.id === product.id);
                    }
                    const newDispatchItem = new IDispatchItemRow();
                    newDispatchItem.product = product;
                    newDispatchItem.productId = product.id;
                    newDispatchItem.closing = testProduct !== undefined ? testProduct.closingAmount.toString() : 'N/A';
                    newDispatchItem.quantity = '';
                    newDispatchItem.price = product.retailPrice;
                    list.push(newDispatchItem);
                }
            });
            list.sort((a, b) => a.product.name.localeCompare(b.product.name));
        }

        if ( this.state.newExpenseList.length > 0) {
            this.state.newExpenseList.forEach(expense => {
                if (!list.find(li => li.expense.name === expense.name)) {
                    const newDispatchItem = new IDispatchItemRow();
                    newDispatchItem.expense = expense;
                    newDispatchItem.expenseId = expense.id;
                    newDispatchItem.price = expense.retailPrice;
                    newDispatchItem.quantity = '';
                    list.push(newDispatchItem);
                }
            });
            list.sort((a, b) => a.expense.name.localeCompare(b.expense.name));
        }
        this.setState({
            isDirty: true,
            [listName]: typeLists,
            newExpenseList: [],
            newInventoryList: [],
        }, () => {
            this.formatDataTableProduct(listName);
            this.toggleModal('product')();
        });
    }

    private getDispatchType = (dispatch: IDispatch) => {
        return dispatch.type;
        // if (dispatch.sourceWellId !== '' && dispatch.destinationWellId !== '') {
        //     return 'Transfer';
        // } else if (dispatch.sourceWellId === '') {
        //     return 'Delivery';
        // } else if (dispatch.destinationWellId === '' ) {
        //     return 'Pickup';
        // }
        // return '';
    }

    private checkForInventoryTests = () => {
        if (!this.props.forWell)
        {
            return true;
        }

        return this.TestsStore.tests.some(t => t.isInventoryReport);
    }

    private getWellNameFromId = (wellId: string) => {
        if (this.state.wellList) {
            const well = this.state.wellList.find(w => w.id === wellId);
            if (well) {
                return well.wellName;
            }
        }
        return '';
    }
    public readyToRender = () => {
        return this.state.deliveryLists.expense
            && this.state.deliveryLists.product
            && this.state.pickupLists.expense
            && this.state.pickupLists.product
            && this.state.transferLists.expense
            && this.state.transferLists.expense
            && this.WellsStore.well
            && this.state.wellList;
    }

    private toggleDispatch = (name: string) => () => {
        const openAccord = this.state.openAccord;
        openAccord[name] = !openAccord[name];
        this.setState({
            openAccord,
        });
    }

    // private handleSaveProduct = () => {
    //     const productList = this.state.productList;
    //     productList.push(this.state.newProduct);
    //     this.setState({
    //         newProduct: new IProduct(),
    //         productList
    //     }, () => {
    //         this.formatAddProductDataTable();
    //         this.toggleModal('newProduct')();
    //     });
    // }

    private toggleModal = (modalName: string) => () => {
        switch(modalName) {
            case 'dispatch':
                this.setState({
                    showDispatchModal: !this.state.showDispatchModal
                });
                break;
            case 'product':
                this.setState({
                    showProductModal: !this.state.showProductModal
                });
                break;
            case 'newProduct':
                this.setState({
                    showNewProductModal: !this.state.showNewProductModal
                });
                break;
        }
    }

    private disableSave = (listName: string) => {
        switch(listName) {
            case 'deliveryLists':
                return false;
            case 'pickupLists':
                return this.state.pickupLists.product.some(p => p.quantity > p.closing);
            case 'transferLists':
                return this.state.transferLists.product.some(p => p.quantity > p.closing);
        }
        return false;
    }

    public addProductModal = (listName: string) => () => {
        this.setState({
            modalTargetList: listName,
            showProductModal: true,
            tab: 'product',
        });
    }

    public addExpenseModal = (listName: string) => () => {
        this.setState({
            modalTargetList: listName,
            showProductModal: true,
            tab: 'expense',
        });
    }
    
    public handleProductInputChange = (event: any) => {
        const newProduct = this.state.newProduct;
        if ( event.target.name === 'categorys' ) {
            if ( this.state.productCategories.length > 0 ) {
                this.state.productCategories.forEach(category => {
                    if (category.id === event.target.value) {
                        newProduct.categorys[0] = category;
                    }
                });
            }
        } else {
            newProduct[event.target.name] = event.target.value;
        }
        this.setState({
            newProduct
        });
    }

    private handleMultiSelect = (listType: string) => (index: number) => {
        if (listType === 'product') {
            const filteredProductList = this.state.productList.filter(this.filterAddProduct(this.state.modalTargetList));
            const filteredIndex = this.state.newInventoryList.indexOf(filteredProductList[index]);
            if ( filteredIndex !== -1 ) {
                this.state.newInventoryList.splice(filteredIndex, 1);
            } else {
                this.state.newInventoryList.push(filteredProductList[index]);
            }
        } else {
            const filteredExpenseList = this.state.expenseList.filter(this.filterAddExpense(this.state.modalTargetList));
            const filteredIndex = this.state.newExpenseList.indexOf(filteredExpenseList[index]);
            if ( filteredIndex !== -1) {
                this.state.newExpenseList.splice(filteredIndex, 1);
            } else {
                this.state.newExpenseList.push(filteredExpenseList[index]);
            }
        }
    }

    private isDirty = () => {

        const deliveryDirty = this.state.deliveryLists.product
            .some(item => item.quantity > 0);

        if (deliveryDirty) {
            return true;
        }

        const pickupDirty = this.state.pickupLists.product
            .some(item => item.quantity > 0);

        if (pickupDirty) {
            return true;
        }
        const transferDirty = this.state.transferLists.product
            .some(item => item.quantity > 0);
        
        if (transferDirty) {
            return true;
        }

        return false;
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        if (this.props.forWell) {
            if ( $target.name === 'previousButton' ) {
                this.props.history.push('/well/' + this.WellsStore.well.id + '/contacts');
            } else {
                this.props.history.push('/well/' + this.WellsStore.well.id + '/review');
            }
        } else {
            if ( $target.name === 'previous' ) {
                this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/inventory/ebp');
            } else {
                this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/inventory/volumeaccounting');
            }
        }

    }

    private canCreateTransfer = () => {
        const destinationWellId = this.state.destinationWellId;
        const preApprovedTest = this.UserStore.hasGenericPermission('Permissions.Dispatch.Approve');
        return preApprovedTest ? destinationWellId !== '' : true;
    }
    // private toggleTab = (tab: string) => () => {
    //     this.setState({tab});
    // }
    public render() {
        if (!this.readyToRender()) {
            return (
            <div>
                { this.props.workflowHeaderItems && <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} />}
                <FontAwesomeIcon 
                    icon={faSpinner}
                    spin={true}
                    size={"8x"}
                    style={{position: 'fixed', left: '50%', top: '35%'}}
                />
            </div>
            );
        }

        return (
            <div>
                <Prompt when={this.isDirty()} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                { this.props.workflowHeaderItems && <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} />}
                {/* <Nav tabs={true} style={{marginBottom: '2.0rem'}}>
                <NavItem style={{marginRight: '1.5rem'}} active={this.state.tab === 'product'}>
                    <Button
                        active={this.state.tab === 'product'}
                        color="light"
                        onClick={this.toggleTab('product')}
                        style={{fontSize: '2.4rem'}}
                    >
                    Products
                    </Button>
                </NavItem>
                <NavItem active={this.state.tab === 'expense'}>
                    <Button
                        active={this.state.tab === 'expense'}
                        color="light"
                        onClick={this.toggleTab('expense')}
                        style={{fontSize: '2.4rem'}}
                    >
                    Expenses
                    </Button>
                </NavItem>
                </Nav> */}
                <Row>
                    <Col>
                        <h4 style={{fontSize: '2.4rem'}} onClick={this.toggleDispatch('delivery')}>
                            <FontAwesomeIcon   
                                icon="chevron-right"
                                color="#003a63"
                                rotation={ this.state.openAccord.delivery ?
                                    90 : 270
                                }
                                transform="shrink-2"
                                style={{marginRight: '10px'}}
                            />
                            Request for Delivery
                        </h4>
                    </Col>
                </Row>
                <Row>
                    <Col>
                {
                    // deliver table here
                    this.state.openAccord.delivery &&
                        <DataTable
                            list={this.state.dataTablesProducts.deliveryLists}
                        />
                }
                    </Col>
                </Row>
                {
                    this.state.openAccord.delivery &&
                    <Row>
                        <Col>
                            <div className='float-right'>
                                <Button type="button" color="primary" onClick={this.addProductModal('deliveryLists')}>
                                    + Add Products
                                </Button>
                                {' '}
                                {/* 
                                REMOVED MUD-3600
                                <Button type="button" color="primary" onClick={this.createDispatch('deliveryLists')}>
                                    Submit Delivery
                                </Button> */}
                            </div>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col>
                {
                    this.state.openAccord.delivery &&
                        <DataTable
                            list={this.formatDataTableExpense('deliveryLists')}
                        />
                }
                    </Col>
                </Row>
                {
                    this.state.openAccord.delivery &&
                    <Row>
                        <Col>
                            <div className='float-right'>
                                <Button type="button" color="primary" onClick={this.addExpenseModal('deliveryLists')}>
                                    + Add Expenses
                                </Button>
                                {' '}
                                {/* 
                                REMOVED MUD-3600
                                <Button type="button" color="primary" onClick={this.createDispatch('deliveryLists')}>
                                    Submit Delivery
                                </Button> 
                                */}
                            </div>
                        </Col>
                    </Row>
                }
                {
                    this.checkForInventoryTests() &&
                <React.Fragment>
                    <Row>
                        <Col>
                            <h4 style={{fontSize: '2.4rem'}} onClick={this.toggleDispatch('pickup')}>
                                <FontAwesomeIcon   
                                    icon="chevron-right"
                                    color="#003a63"
                                    rotation={ this.state.openAccord.pickup ?
                                        90 : 270
                                    }
                                    transform="shrink-2"
                                    style={{marginRight: '10px'}}
                                />
                                Request for Pickup
                            </h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                    {
                        // deliver table here
                        this.state.openAccord.pickup &&
                            <DataTable
                                list={this.state.dataTablesProducts.pickupLists}
                            />
                    }
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                    {
                        // deliver table here
                        this.state.openAccord.pickup &&
                            <DataTable
                                list={this.formatDataTableExpense('pickupLists')}
                            />
                    }
                        </Col>
                    </Row>
                    {
                        this.state.openAccord.pickup &&
                        <Row>
                            <Col>
                                <div className='float-right'>
                                    {/* Removed MUD-3461
                                    <Button type="button" color="primary" onClick={this.addProductModal('pickupLists')}>
                                        + Add Products
                                    </Button> */}
                                    <Button type="button" color="primary" onClick={this.addExpenseModal('pickupLists')}>
                                    + Add Expenses
                                    </Button>
                                    {' '}
                                    {/* 
                                    REMOVED MUD-3600
                                    <Button 
                                        type="button"
                                        color="primary"
                                        onClick={this.createDispatch('pickupLists')}
                                        disabled={this.disableSave('pickupLists')}
                                    >
                                        Submit Pickup
                                    </Button> 
                                    */}
                                </div>
                            </Col>
                        </Row>
                    }
                </React.Fragment>
                }
                {
                this.checkForInventoryTests() &&
                <React.Fragment>
                    <Row>
                        <Col>
                            <h4 style={{fontSize: '2.4rem'}} onClick={this.toggleDispatch('transfer')}>
                                <FontAwesomeIcon   
                                    icon="chevron-right"
                                    color="#003a63"
                                    rotation={ this.state.openAccord.transfer ?
                                        90 : 270
                                    }
                                    transform="shrink-2"
                                    style={{marginRight: '10px'}}
                                />
                                Request for Transfer
                            </h4>
                        </Col>
                    </Row>
                    {
                        this.state.openAccord.transfer &&
                        <FormGroup row={true}>
                            <Label for="sourceWell" md={3}>
                                Source Well: 
                            </Label>
                            <Col md={3}>
                                <Input
                                    type="text"
                                    id="sourceWell"
                                    name="sourceWell"
                                    value={this.WellsStore.well.wellName}
                                    disabled={true}
                                />
                            </Col>
                            <Label for="destinationWell" md={3}>
                                Destination Well:
                            </Label>
                            <Col md={3}>
                                <Input
                                        type="select"
                                        id="destinationWell"
                                        name="destinationWell"
                                        value={this.state.destinationWellId}
                                        onChange={this.handleDestWellChange}
                                >
                                    <option />
                                    {
                                        this.state.wellList &&
                                        this.state.wellList.filter(w => w.id !== this.WellsStore.well.id).map((well, index) => 
                                            <option key={well.id} value={well.id}>
                                                {well.wellName}
                                            </option>
                                        )
                                    }
                                </Input>
                            </Col>
                        </FormGroup>
                    }
                    {
                        this.state.openAccord.transfer && !this.canCreateTransfer() &&
                        <Row>
                            <Col>
                                <p style={{color: 'red'}}>You cannot submit this dispatch request for transfer without a Destination Well Chosen</p>
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col>
                    {
                        // deliver table here
                        this.state.openAccord.transfer &&
                            <DataTable
                                list={this.state.dataTablesProducts.transferLists}
                            />
                    }
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                    {
                        // deliver table here
                        this.state.openAccord.transfer &&
                            <DataTable
                                list={this.formatDataTableExpense('transferLists')}
                            />
                    }
                        </Col>
                    </Row>
                    {
                        this.state.openAccord.transfer &&
                        <Row>
                            <Col>
                                <div className='float-right'>
                                    {/* Removed MUD-3461
                                    <Button type="button" color="primary" onClick={this.addProductModal('transferLists')}>
                                        + Add Products
                                    </Button> */}
                                    <Button type="button" color="primary" onClick={this.addExpenseModal('transferLists')}>
                                    + Add Expenses
                                    </Button>
                                    {' '}
                                    {/* 
                                    REMOVED MUD-3600
                                    <Button 
                                        type="button"
                                        color="primary"
                                        onClick={this.createDispatch('transferLists')}
                                        disabled={this.disableSave('transferLists') || !this.canCreateTransfer()}
                                    >
                                        Submit Transfer
                                    </Button> 
                                    */}
                                </div>
                            </Col>
                        </Row>
                    }
                </React.Fragment>
                }
                { this.props.forWell ?
                    <ButtonRow>
                        <WellRevertCloseButton />
                        <WellCloseButton />
                        <Button className="secondary" name="previousButton" onClick={this.buttonNavigation}>Previous</Button>
                        <Button type="button" color="primary" onClick={this.createDispatch('deliveryLists')}>
                            Submit Delivery
                        </Button>
                        <Button 
                            type="button"
                            color="primary"
                            onClick={this.createDispatch('pickupLists')}
                            disabled={this.disableSave('pickupLists')}
                        >
                            Submit Pickup
                        </Button>
                        <Button 
                            type="button"
                            color="primary"
                            onClick={this.createDispatch('transferLists')}
                            disabled={this.disableSave('transferLists') || !this.canCreateTransfer()}
                        >
                            Submit Transfer
                        </Button>
                        <Button className="secondary" name="nextButton" onClick={this.buttonNavigation}>Next</Button>
                        <WellFooter />
                    </ButtonRow>
                :
                <Footer well={this.WellsStore.well} test={this.TestsStore.test} onNavigate={this.buttonNavigation} saveDisabled={true}>
                    <Button type="button" color="primary" onClick={this.createDispatch('deliveryLists')}>
                        Submit Delivery
                    </Button>
                    <Button 
                        type="button"
                        color="primary"
                        onClick={this.createDispatch('pickupLists')}
                        disabled={this.disableSave('pickupLists')}
                    >
                        Submit Pickup
                    </Button>
                    <Button 
                        type="button"
                        color="primary"
                        onClick={this.createDispatch('transferLists')}
                        disabled={this.disableSave('transferLists') || !this.canCreateTransfer()}
                    >
                        Submit Transfer
                    </Button>
                </Footer>
                }
                <Modal isOpen={this.state.showDispatchModal} toggle={this.toggleModal('dispatch')}>
                    <ModalHeader toggle={this.toggleModal('dispatch')}>
                        Review {this.getDispatchType(this.state.dispatch)} Dispatch
                    </ModalHeader>
                    <ModalBody>
                        {
                            this.state.dispatch.sourceWellId &&
                            this.getWellNameFromId(this.state.dispatch.sourceWellId) &&
                            <FormGroup row={true}>
                                <Label md={6}>
                                    Source Well
                                </Label>
                                <Col md={6}>
                                    <Input
                                        type="text"
                                        name="sourceWellModal"
                                        id="sourceWellModal"
                                        value={this.getWellNameFromId(this.state.dispatch.sourceWellId)}
                                        disabled={true}
                                    />  
                                </Col>
                            </FormGroup>
                        }
                        {
                            this.state.dispatch.destinationWellId &&
                            this.getWellNameFromId(this.state.dispatch.destinationWellId) &&
                            <FormGroup row={true}>
                                <Label md={6}>
                                    Destination Well
                                </Label>
                                <Col md={6}>
                                    <Input
                                        type="text"
                                        name="destinationWellModal"
                                        id="destinationWellModal"
                                        value={this.getWellNameFromId(this.state.dispatch.destinationWellId)}
                                        disabled={true}
                                    />  
                                </Col>
                            </FormGroup>
                        }
                        <FormGroup row={true}>
                            <Col>
                                <Label className="required">RTA</Label>
                            </Col>
                            <Col>
                                <DateTime
                                    value={ this.state.dispatch.requestedArrival ? moment.unix(Number(this.state.dispatch.requestedArrival)) : undefined }
                                    onChange={this.handleDispatchDateChange}
                                />
                            </Col>
                        </FormGroup>
                        <Row>
                            <Col>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.dispatch && this.state.dispatch.items &&
                                            this.state.dispatch.items.map((item, index) => 
                                            <tr key={index}>
                                                <td>{item.product ? item.product.name : item.expense.name}</td>
                                                <td>{item.quantity}</td>
                                            </tr>
                                            )
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label>Add Comments:</Label>
                                <Input
                                    type="textarea"
                                    id="comment"
                                    name="comment"
                                    value={this.state.dispatch.comment}
                                    onChange={this.handleDispatchChange}
                                />
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleModal('dispatch')}>Cancel</Button>
                        <Button color="primary" disabled={!this.state.dispatch.requestedArrival} onClick={this.saveDispatch(this.state.modalTargetList)}>Submit Dispatch</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showProductModal} fade={false} toggle={this.toggleModal('product')} style={{'maxWidth': 'fit-content'}}>
                    <ModalHeader toggle={this.toggleModal('product')}>{this.state.tab === 'product' ? 'Product' : 'Expense'} List</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md="12">
                                <DataTable
                                    list={this.state.tab === 'product' ? this.formatAddProductDataTable() : this.formatAddExpenseDataTable()}
                                    onMultiSelect={this.handleMultiSelect(this.state.tab)}
                                />
                            </Col>
                        </Row>
                        {/* <div className="add-table-row">
                            <Button className="primary add-new-button" onClick={this.toggleModal('newProduct')}>
                                        <FontAwesomeIcon icon="plus" />
                                        { ' User Defined Product' }
                            </Button>
                        </div> */}
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleModal('product')}>Cancel</Button>
                        <Button color="primary" onClick={this.handleSave(this.state.modalTargetList, this.state.tab)}>Add to Inventory</Button>
                    </ModalFooter>
                </Modal>
                {/* Removed Mud-3404
                    <Modal isOpen={this.state.showNewProductModal} fade={false} toggle={this.toggleModal('newProduct')}>
                    <ModalHeader toggle={this.toggleModal('newProduct')}> User Defined Product </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label>Product</Label>
                                    <Input
                                        type="text"
                                        name="name"
                                        id="name"
                                        value={this.state.newProduct.name}
                                        onChange={this.handleProductInputChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label>Category</Label>
                                    <Input
                                        type="select"
                                        name="categorys"
                                        id="categorys"
                                        value={this.state.newProduct.categorys[0] ?
                                            this.state.newProduct.categorys[0].id : ''
                                        }
                                        onChange={this.handleProductInputChange}
                                        >
                                        <option />
                                        { this.state.productCategories && this.state.productCategories.map((productCategory: IProductCategory ,key: number) =>
                                            <option key={key} value={productCategory.id}>{productCategory.name}</option>
                                        ) }
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label>Size</Label>
                                    <Input
                                        type="text"
                                        name="size"
                                        id="size"
                                        value={this.state.newProduct.size}
                                        onChange={this.handleProductInputChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label>Unit</Label>
                                    <Input
                                        type="text"
                                        name="unit"
                                        id="unit"
                                        value={this.state.newProduct.unit}
                                        onChange={this.handleProductInputChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label>Weight</Label>
                                    <Input
                                        type="text"
                                        name="weight"
                                        id="weight"
                                        value={this.state.newProduct.weight}
                                        onChange={this.handleProductInputChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label>Specific Gravity</Label>
                                    <Input
                                        type="text"
                                        name="specificGravity"
                                        id="specificGravity"
                                        value={this.state.newProduct.specificGravity}
                                        onChange={this.handleProductInputChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label>Price</Label>
                                    <Input
                                        type="text"
                                        name="retailPrice"
                                        id="retailPrice"
                                        value={this.state.newProduct.retailPrice}
                                        onChange={this.handleProductInputChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleModal('newProduct')}>Cancel</Button>
                        <Button className="primary" onClick={this.handleSaveProduct}>Add Product</Button>
                    </ModalFooter>
                </Modal> */}
            </div>
        );
    }
}

export default withRouter(Dispatch);



// WEBPACK FOOTER //
// ./src/Components/Main/Dispatch/Dispatch/Dispatch.tsx